




import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ProgressBar extends Vue {
  @Prop() task!: String;

  get progress() {
    switch (this.task) {
      case "bala":
        return this.$store.state.balaProgress;
      case "ttmj":
        return this.$store.state.ttmjProgress;
      default:
        return this.$store.state.balliProgress;
    }
  }

  get colour() {
    switch (this.task) {
      case "bala":
        return this.$vuetify.theme.themes.light.secondary;
      case "ttmj":
        return this.$vuetify.theme.themes.light.warning;
      default:
        return this.$vuetify.theme.themes.light.primary;
    }
  }
}
